exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".examScoreHolder,.loading-container,.sub_options{display:none}.memberExamTable td{font-size:11px}", ""]);

// exports
